<div class="a11y-widget" [class.open]="open()">
  <button
    type="button"
    class="a11y-trigger"
    [attr.aria-label]="texts.trigger"
    [attr.aria-expanded]="open()"
    aria-controls="a11y-panel"
    [title]="texts.title"
    (click)="togglePanel()"
  >
    <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <circle cx="12" cy="4" r="2" />
      <path
        d="M19 8.5c-2.2.5-4.6.8-7 .8s-4.8-.3-7-.8l-.5 2c1.7.4 3.5.7 5.5.8V14l-2.2 6.5 1.9.6L12 15.2l2.3 5.9 1.9-.6L14 14v-2.7c2-.1 3.8-.4 5.5-.8z"
      />
    </svg>
  </button>

  @if (open()) {
    <section id="a11y-panel" class="a11y-panel" role="dialog" [attr.aria-label]="texts.title">
      <header class="a11y-panel__header">
        <h2>{{ texts.title }}</h2>
        <button type="button" class="a11y-close" [attr.aria-label]="texts.close" (click)="closePanel()">×</button>
      </header>

      <div class="a11y-font" role="group" [attr.aria-label]="texts.fontSize">
        <span class="a11y-font__label">{{ texts.fontSize }}</span>
        <div class="a11y-font__controls">
          <button
            type="button"
            [attr.aria-label]="texts.decrease"
            [disabled]="!a11y.canDecreaseFont"
            (click)="a11y.decreaseFont()"
          >
            A−
          </button>
          <output aria-live="polite">{{ fontPercent }}%</output>
          <button
            type="button"
            [attr.aria-label]="texts.increase"
            [disabled]="!a11y.canIncreaseFont"
            (click)="a11y.increaseFont()"
          >
            A+
          </button>
        </div>
      </div>

      <ul class="a11y-options">
        @for (option of options; track option.flag) {
          <li>
            <button
              type="button"
              class="a11y-option"
              [class.active]="isActive(option)"
              [attr.aria-pressed]="isActive(option)"
              [disabled]="isDisabled(option)"
              [title]="isDisabled(option) ? texts.speechUnavailable : option.hint"
              (click)="toggleOption(option)"
            >
              <span class="a11y-option__icon" [attr.data-icon]="option.icon" aria-hidden="true"></span>
              <span class="a11y-option__text">
                <span class="a11y-option__label">{{ option.label }}</span>
                <span class="a11y-option__hint">{{ option.hint }}</span>
              </span>
            </button>
          </li>
        }
      </ul>

      <footer class="a11y-panel__footer">
        <button type="button" class="a11y-reset" [disabled]="a11y.isDefault" (click)="a11y.reset()">
          {{ texts.reset }}
        </button>
      </footer>
    </section>
  }
</div>
